'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import { Category, CategoryVideo, CategoryVideosResponse } from '@insta-club/models';
import { EducationalPostItem } from 'src/libs/components/common';
import ContentWrapper from 'src/libs/components/common/contentWrapper';
import { Swiper, SwiperSlide } from 'swiper/react';
import useSWR from 'swr';

function LatestAcademyVideo({ categories }: { categories: Category[] }) {
    const category_ids = categories.map((item) => item.id);

    const { isLoading, data } = useSWR<CategoryVideosResponse>(ApiKeys.GET_EDUCATIONAL_POSTS, (url: string) =>
        fetcher(url, 'dashboard', 'GET', {
            body: {
                category_ids: category_ids
            }
        })
    );

    if (isLoading) {
        return (
            <div className='mx-6 h-[313] w-[202]'>
                <div className='animate-pulse'>
                    <div className='relative overflow-hidden rounded-2xl'>
                        <div className='relative aspect-[4/3] h-[250px] w-full bg-gray-200' />
                        <div className='absolute inset-0 z-[1] flex items-center justify-center bg-gradient-to-b from-transparent via-transparent to-black/60'>
                            <div className='h-14 w-14 rounded-full bg-gray-300' />
                        </div>
                    </div>
                    <div className='mt-2 space-y-2'>
                        <div className='h-4 w-3/4 rounded bg-gray-300' />

                        <div className='mt-2 flex items-center'>
                            <div className='ml-1 h-7 w-7 rounded-full bg-gray-300' />
                            <div className='h-3 w-1/2 rounded bg-gray-300' />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const groupedVideos: Record<number, { categoryName: string; videos: CategoryVideo[] }> =
        data?.data.reduce(
            (acc, video) => {
                video.categories.forEach((category) => {
                    if (!acc[category.id]) {
                        acc[category.id] = {
                            categoryName: category.name,
                            videos: []
                        };
                    }
                    acc[category.id].videos.push(video);
                });
                return acc;
            },
            {} as Record<number, { categoryName: string; videos: CategoryVideo[] }>
        ) ?? {};

    return (
        <>
            {Object.keys(groupedVideos).map((categoryIdStr) => {
                const categoryId = Number(categoryIdStr);
                const group = groupedVideos[categoryId];

                if (!group) return null;

                return (
                    <ContentWrapper
                        key={categoryId}
                        title={group.categoryName}
                        link={{
                            title: 'نمایش همه',
                            href: `/videos?category_id=${categoryId}`
                        }}
                    >
                        {group.videos.length === 0 ? (
                            <div className='mx-6 h-[313] w-[202]'>
                                <div className='animate-pulse'>
                                    <div className='relative overflow-hidden rounded-2xl'>
                                        <div className='relative aspect-[4/3] h-[250px] w-full bg-gray-200' />
                                        <div className='absolute inset-0 z-[1] flex items-center justify-center bg-gradient-to-b from-transparent via-transparent to-black/60'>
                                            <div className='h-14 w-14 rounded-full bg-gray-300' />
                                        </div>
                                    </div>
                                    <div className='mt-2 space-y-2'>
                                        <div className='h-4 w-3/4 rounded bg-gray-300' />

                                        <div className='mt-2 flex items-center'>
                                            <div className='ml-1 h-7 w-7 rounded-full bg-gray-300' />
                                            <div className='h-3 w-1/2 rounded bg-gray-300' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <Swiper
                                slidesPerView={'auto'}
                                spaceBetween={24}
                                slidesOffsetBefore={24}
                                slidesOffsetAfter={24}
                            >
                                {group.videos.map((video: CategoryVideo) => (
                                    <SwiperSlide key={video.id} style={{ width: 202, height: 313 }}>
                                        <EducationalPostItem item={video} />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        )}
                    </ContentWrapper>
                );
            })}
        </>
    );
}

export default LatestAcademyVideo;

